import { useContext } from "react";
import { SemesterContext } from "../contexts/SemesterContext";

export default function useSemester() {
  return useContext(SemesterContext);
}
